<header>
  <nav class="navbar">
    <div class="container">
      <div class="head-menu">
        <div class="left-logo" [ngClass]="{'ab-new-design-loan-type': newDesignLoanTypeABTest, 'top10-new-footer-form': isTop10newFooterForm}">
          @if (!recommendedLenderActive) {
            <p>
              @if (siteLogo) {
                <img class="logo" [src]="brandService.abLogoSrc !== '' ? brandService.abLogoSrc : brandService.logoSrc">
              }
              @if (brandService.logoSrc && !siteLogo) {
                <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}} also with extra" [errorSrc]="brandService.logoWasabiSrc">
              }
            </p>
          }
          @if (recommendedLenderActive) {
            <p>
              @if (brandService.logoSrc) {
                <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" [errorSrc]="brandService.logoWasabiSrc">
              }
            </p>
          }
        </div>
        @if (!corporateBrandOnly) {
          <div class="advertiser-identity">
            <span>Powered by</span>
            <img [src]="corporateLogoSrc" alt="FreeRateUpdate.com">
          </div>
        }
        @if (lenderHeadPhoneStatus && lenderHeadPhoneStatus.answer && !brandService.isTop10) {
          <div class="phone">
            <a class="has-text-grey-dark" href="tel:{{ lenderHeadPhoneStatus.phone }}" target="_blank">
              <small>or call for rates...</small>
              <i class="fas fa-phone"></i>{{ lenderHeadPhoneStatus.phonefancy }}
            </a>
          </div>
        }
      </div>
    </div>
  </nav>
</header>
